<template src="./AppHeader.html"></template>
<style lang='scss' scoped src="./AppHeader.scss"></style>
<script>
import {
  SfButton,
  SfHeader,
  SfIcon,
  SfImage,
  SfMegaMenu,
  SfSearchBar,
  SfOverlay,
  SfBadge,
  SfLoader,

} from '@storefront-ui/vue';
import {OrkLoader} from "@/components/Ork";
import SearchResults from '@/components/SearchResults';
import SearchAutocomplete from '@/components/SearchAutocomplete';
import {icons} from "@/utils/icons";
import {clickOutside} from '@storefront-ui/vue/src/utilities/directives/click-outside/click-outside-directive.js';
import Api from "@/api/Api";

export default {
  name: 'AppHeader',
  components: {
    OrkLoader,
    SfButton,
    SfHeader,
    SfImage,
    SfIcon,
    SfMegaMenu,
    SfSearchBar,
    SfBadge,
    SfLoader,
    SfOverlay,
    SearchResults,
    SearchAutocomplete,
  },
  data() {
    return {
      icons: icons,
      term: '',
      debounceSearch: null,
      searchValue: '',
      activeMenu: null,
      isShowMenu: false,
      loadingSearch: false,
      accountIcon: 'profile',
      cartTotalItems: 0,
      searchResult: {content: [], totalItems: 0, loading: false},
      searchTerm: '',
      searchTerms: [],
      showAutocomplete: false,
      navAnnexe: [
        {
          label: 'Blog',
          link: '/blog'
        },
        {
          label: 'linkedIn',
          link: '',
          icon: 'M23 23v-8.1c0-4-.9-7-5.4-7-2.2 0-3.7 1.2-4.3 2.4h-.1v-2H8.8V23h4.6v-7.3c0-1.9.4-3.8 2.7-3.8s2.4 2.2 2.4 3.9v7.1l4.5.1zM1.4 8.4H6V23H1.4V8.4zM3.6 1C2.2 1 1 2.2 1 3.6s1.2 2.6 2.6 2.6S6.3 5 6.3 3.6 5.1 1 3.6 1z'
        },
        {
          label: 'facebook',
          link: '',
          icon: 'M15.997 3.985h2.191V.169C17.81.117 16.51 0 14.996 0c-3.159 0-5.323 1.987-5.323 5.639V9H6.187v4.266h3.486V24h4.274V13.267h3.345l.531-4.266h-3.877V6.062c.001-1.233.333-2.077 2.051-2.077z'
        }
      ],
      featuredProducts: undefined
    };
  },
  directives: {clickOutside},
  computed: {
    isSearchOpen: {
      get() {
        return this.$store.getters.isSearchOpen
      }
    },
    categoryTree: {
      get() {
        return this.$store.getters.getCategoryTree
      }
    },
    user: {
      get() {
        return this.$store.getters.getProfile
      }
    },
    isAuthenticated: {
      get() {
        return this.$store.getters.isAuthenticated
      }
    },
    cart: {
      get() {
        return this.$store.getters.getCart
      }
    },
    locale: {
      get() {
        return this.$i18n.locale
      }
    }
  },


  mounted() {
    this.fetchFeaturedProducts().then((response) => { this.featuredProducts = response });
  },

  watch: {
    categoryTree() {
      this.fetchFeaturedProducts().then((response) => { this.featuredProducts = response });
    }
  },

  methods: {
    async fetchFeaturedProducts() {
      if (!this.categoryTree) {
        return null;
      }

      const featuredProducts = {};
      for (const category of this.categoryTree.children) {
        try {
          const marketingCategory = await Api.marketing.getCategory(category.path);

          if (marketingCategory.featuredProducts) {
            featuredProducts[category.slug] = await Api.product.getBySkuList(marketingCategory.featuredProducts.join(","));
          }
        } catch (e) {
        }
      }

      return featuredProducts;
    },
    showMenu(isShow, category) {
      this.activeMenu = category;
      this.isShowMenu = isShow;
    },
    // mutation de isModalLogin
    handleAccountClick() {
      if (this.isAuthenticated) {
        return this.$router.push(this.$localizePath('/mon-compte/profil')).catch();
      } else {
        this.$store.dispatch('toggleLoginModal', {open: true})
      }
    },
    toggleCartSidebar() {
      this.$store.dispatch('toggleCartSidebar')
    },
    removeSearchResults() {
      this.searchTerms = [];
      this.searchResult = {content: [], totalItems: 0, loading: false}
    },
    closeSearch() {
      //  this.searchTerm = '';
      this.searchTerms = [];
      this.searchResult = {content: [], totalItems: 0, loading: false}
      this.$store.dispatch('closeSearch')
    },

    toggleSearch() {
      this.$store.dispatch('toggleSearch')
    },

    openSearch() {
      this.$store.dispatch('openSearch')
    },
    closeAutocomplete() {
      this.showAutocomplete = false;
    },
    getLengthTerm(term) {
      let lengthTerm = 0;
      for (let i = 0, len = term.length; i < len; i++) {
        if (term[i] !== ' ')
          lengthTerm++;
      }
      return lengthTerm;
    },
    handleSearchAutoComplete(term) {
      clearTimeout(this.debounceSearch);
      this.searchTerm = term;

      if (this.getLengthTerm(this.searchTerm) >= 3) {

        this.debounceSearch = setTimeout(() => {
          this.loadingSearch = true;

          Api.product.searchAutocomplete(term).then((data) => {
            this.showAutocomplete = true;
            this.searchTerms = data;
          }).catch((e) => {
            this.$store.dispatch('sendNotification', {
              type: 'danger',
              message: this.$i18n.t('server error'),
              icon: icons.error
            });
          }).finally(() => {
            this.loadingSearch = false;
          })
        }, 300);
      }


    },

    changeSearchTerm(term) {
      this.searchTerm = term;
      this.showAutocomplete = false;
      this.handleSearch(term)

    },

    handleSearch(term) {
      this.goToSearch()
      /*  if (this.searchTerm.length > 0) {
          this.loadingSearch = true;
          let content = [];
          this.searchResult = {content: content, totalItems: 0, loading: this.loadingSearch}

          this.openSearch()
          Api.product.search(term).then((data) => {

            for (let lightProduct of data.products.content) {
              content.push(LightProduct.of(lightProduct));
            }
            this.searchResult = {content: content, totalItems: data.products.totalElements, loading: false}

          }).catch((e) => {
            console.error(e)
          }).finally(() => {
                this.loadingSearch = false

              }
          )
        }*/
    },

    goToSearch() {

      this.searchResult = {content: [], totalItems: 0};
      this.$store.dispatch('closeSearch')
      this.$router.push(this.$localizePath('/recherche?searchTerm=' + this.searchTerm)).catch(() => {
        return null
      })
    }
  }
};
</script>


